export function isABNValid(abn: string) {
  /**
   * ABN's have a checksum in addition to required length of 11
   * Read more here: https://abr.business.gov.au/Help/AbnFormat
   * For now, using variation of implementation from below:
   * https://gist.github.com/airtonix/7129b0ed825a929bac8120efa6e9466f
   */

  const trimmedABN = abn.replaceAll('-', '').split(' ').join('');
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  let checkSum = 0;

  // Short out if abn isn't numeric or has incorrect length or starts w/ 0
  if (
    trimmedABN.match(/^[\0-9]+$/) === null ||
    trimmedABN.length !== 11 ||
    trimmedABN[0] === '0'
  ) {
    return false;
  }

  for (let i = 0; i <= weights.length - 1; i += 1) {
    const digit = parseInt(trimmedABN[i]) - (i ? 0 : 1);
    checkSum += weights[i] * digit;
  }

  return checkSum % 89 === 0;
}

export function isPostalCodeValid(postalCode: string, country: string) {
  let re = null;

  switch (country) {
    case 'US':
      re = /^\d{5}(?:-\d{4})?$/;
      break;
    case 'CA':
      re =
        /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]([- ]?\d[ABCEGHJ-NPRSTV-Z]\d)?$/i;
      break;
    case 'GB':
      re = /^([A-Z][A-HJ-Y]?\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/i;
      break;
    default:
      break;
  }

  if (!re) return true;

  return re.test(postalCode);
}
